module.exports = __webpack_public_path__ + "static/media/s5.19ebc4d3.png";